// Import react
import React, { useState, useEffect } from "react";
import Header from "../components/header/clientHeader";
import Cards from "../components/board/clientCards";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Buffer } from "buffer";
import Login from "../components/loginModal/dashboardLogin";
import Box from "@mui/material/Box";

// Import react
import {
    getClientAllBoards,
    getClientProfilesDetails,
} from "../redux/actions/actions";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Snackbar from "@mui/material/Snackbar";

// Import custom components
function Board() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = "Candidate boards";
    const {client_Boards,detailed_client_Profiles} = useSelector((state) => state.client);

    const [boards, setBoards] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [showMessage, setShowMessage] = useState(false);
    const [successfullMessage, setSuccessfullMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
  
    useEffect(async() => {
      window.scrollTo(0, 0);

      var url = new URL(window.location.href);
      var dashboard_id = url.searchParams.get("dashboard").split("/")[0];
      var dashboardId = Buffer.from(dashboard_id || "", "base64").toString("utf-8");

      dashboardId && await dispatch(getClientAllBoards(dashboardId)).then(() => {
      }).catch(() => {
        setSuccessfullMessage("Something went wrong.");
      })
    }, []);

    useEffect(() => {
        if(client_Boards.length > 0){
            all_profiles(client_Boards) 
        }
    }, [client_Boards]);

    useEffect(() => {
        if(detailed_client_Profiles.length > 0 && client_Boards.length > 0){
            let client_boards = [...boards];
            detailed_client_Profiles.forEach((profile,i) => 
                {
                    client_Boards.forEach((board,index) => {
                        if(board.profiles.find(p => p.id == profile.id)){
                            client_boards[index]?.candidates?.push({emoji_url : profile.emoji_url, full_name:profile.full_name, bg_color : getRandomColor()})
                        }
                    })
                })
            setBoards(client_boards);
            setShowLoader(false); 
        }
    }, [detailed_client_Profiles]);
  
    const all_profiles = async(boards) => {
        let allIds = [];
        var all_profiles = [];
        var board_all_Profiles = [];

        boards.forEach( (board) => {
            let p =board?.profiles ? board.profiles : []
            all_profiles.push(p);

            board_all_Profiles.push({
            "id" : board.id,
            "board_url" : board?.url_with_token || "",
            "expireDate" : board?.expireDate,
            "activeLink": board?.enabled,
            "title" : board.board.name,
            "sharedAt": board.link_shared_at,
            "remainingDays" : remainingDaysForLink(board.expireDate,board.link_shared_at),
            "boardProfilesWithoutDetails" : board?.profiles,
            "candidates" : []
            })
        })
        
        setBoards(board_all_Profiles);
     
          all_profiles.forEach( (profiles) => {
            for(var i =0 ; i< profiles?.length ; i++){
              if(!allIds.includes(profiles[i].id) && allIds.length > 0){
                  allIds.push(profiles[i].id);
              }
              else if(allIds.length == 0){
                  allIds.push(profiles[i].id);
              }
            }
        })

        dispatch(getClientProfilesDetails(allIds));
      
    }
  
    function getRandomColor() {
        var letters = 'BCDEF'.split('');
        var color = '#';
        for (var i = 0; i < 6; i++ ) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
      }
  
    const remainingDaysForLink = (expire,linkSharedAt) => {
        const link_shared_at = new Date(linkSharedAt);

        // Today's date
        const currentDate = new Date();

        // Link expire date
        let expireDate = new Date();
        expireDate.setDate(link_shared_at.getDate() + expire);

        // To calculate the time difference of two dates
        let Difference_In_Time = expireDate.getTime() - currentDate.getTime();

        // To calculate the no. of days between two dates
        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        Difference_In_Days = Difference_In_Days > 0 ? Difference_In_Days : 0;
        return Difference_In_Days;
    }

    const action = (
      <React.Fragment>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => setShowMessage(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </React.Fragment>
    );

    const style = {
        position: 'absolute',
        zIndex: '100',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        borderRadius: "5px",
        padding: "20px",
        '@media (max-width: 800px)': {
          width: '90%',
          padding: '10px'
        },
      };

    return (
        <div className="bg-[#E9F7FF] min-h-screen h-auto pb-10">
          <Header current="client" showLogin={localStorage.getItem("supabase.auth.token") ? false : true} handleOpenModal={() => setShowModal(true) }/>
          {/* Notification */}
        
          {
            <Snackbar
              open={showMessage}
              onClose={() => setShowMessage(false)}
              autoHideDuration={2000}
              message={successfullMessage}
              action={action}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            />
          }

        {
            showModal &&  <Box sx={style}> <Login handleCloseModal={() => setShowModal(false)}/></Box>
        }

          {/* Page heading  */}
          <div className="flex flex-col items-center justify-center my-10 space-y-5">
              <div className="flex flex-col items-center justify-center space-y-3">
                  <h1 className="text-[32px] md:text-5xl font-bold leading-12">{user}</h1>
                  <h2 className="text-2xl font-medium leading-6 ">Manage boards</h2>
              </div>
          </div>

          {/* Cards */}
          <div className="flex flex-wrap justify-center mx-auto gap-x-6 gap-y-9 max-w-7xl md:mt-5">
              <Cards boards={boards} showLoader={showLoader}/>
          </div>
      </div>
    )
}

export default Board;